import {action} from "mobx";
import locationService from "../services/locationService";
import appStore from "./appStore";
class locationStore {
    @action listAutocompleteAddresses = async params => {
        const resultOfRequest = await locationService.listAutocompleteAddresses(params);
        if (resultOfRequest.status !== 200) {
            //appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };
    @action getLocationDetail = async params => {
        const resultOfRequest = await locationService.getLocationDetail(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
}

export default new locationStore();
